import { wrapper } from '@/redux/store'
import Head from 'next/head'
import { getInitPageAction } from '@/redux/actions/editor'
import { EditConfigType, EditorFlagEum } from '@/typings/types'
import { LangEum, LocalEum } from '@/constant'
// import errorHandler from '@/utils/errorHandler'
import App from '../../components/app'
import { useEffect } from 'react'

if (typeof window !== 'undefined') {
  require('@/utils/img-lazy-load')
}

// errorHandler()
const noOverlayWorkaroundScript = `
  window.addEventListener('error', event => {
    event.stopImmediatePropagation()
  })

  window.addEventListener('unhandledrejection', event => {
    event.stopImmediatePropagation()
  })
`

const setRootFontSize = `
(function(){
  function setSize(){
   document.documentElement.style.fontSize = document.documentElement.clientWidth / 375 * 100 + 'px';
  }
  setSize()
  window.onresize = setSize
 })()`

// in a <Head> component:
// REMOVE error layput
function Root(props: any) {
  useEffect(() => {
    try {
      const pathname = window.location.pathname
      const detailUrlPattern = /^\/poizon\/detail\/([^/]+)\/([^/]+)\/([^/?]+)/
      const match = pathname.match(detailUrlPattern)

      let lang = ''
      let area = ''
      let id = ''
      if (match) {
        lang = match[1] // zh-TW
        area = match[2] // HK
        id = match[3] // 67c94ef9aade3b013053adeb
      }
      console.log('page view', {
        pathname,
        lang: lang || 'default',
        area: area || 'default',
        id: id || 'default',
        user_agent: navigator.userAgent || 'default',
      })
      ;(window as any).DUOTEL?.send('page_view', {
        pathname,
        lang: lang || 'default',
        area: area || 'default',
        nezha_id: id || 'default',
        user_agent: navigator.userAgent || 'default',
      })
    } catch (error) {
      console.error(error)
    }
  }, [])
  return (
    <>
      <Head>
        {process.env.NODE_ENV !== 'production' && (
          <script dangerouslySetInnerHTML={{ __html: noOverlayWorkaroundScript }} />
        )}
        <script dangerouslySetInnerHTML={{ __html: setRootFontSize }}></script>
      </Head>
      <Head>
        <meta httpEquiv="x-dns-prefetch-control" content="on" />
        <link rel="preconnect" href="https://cdn.poizon.com"></link>
        <link rel="dns-prefetch" href="https://cdn.poizon.com"></link>
        <link
          rel="preload"
          href="https://cdn.poizon.com/node-common/SGVsdmV0aWNhTmV1ZS1Db25kZW5zZWRCb2xkMTU5MTI3NjM3NTU4Mw==.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="true"
        ></link>
        {process.env.SENV == 'pre' ? (
          <script src="https://cdn.poizon.com/node-common/e9facf649e10b9bd9452ae10280c09f8.p113a93191af80ff7"></script>
        ) : (
          <script src="https://cdn.poizon.com/node-common/0d11c0490a0c98144c0b103b97299a13.t113a93191af80ff7"></script>
        )}
      </Head>
      <style jsx global>{`
        html {
          font-size: 100px;
        }
      `}</style>

      <App {...props} />
    </>
  )
}


// getServerSideProps begin
export const getServerSideProps = wrapper.getServerSideProps(async (ctx) => {
  const { store, req } = ctx
  const pathStr = req.url.split('?')[0]
  const pathList = pathStr.split('/').slice(2)
  if (Array.isArray(pathList) && pathList.length === 4) {
    const [editorFlag, lang, local, id] = pathList
    const editConfig: EditConfigType = {
      lang: lang as LangEum,
      local: local as LocalEum,
      id,
      editorFlag: editorFlag as EditorFlagEum,
    }
    const action = await getInitPageAction({
      editConfig,
      req,
    })
    store.dispatch(action)
    return {
      props: { hasGetDetail: true }
    }
  }
  return {
    props: {},
  }
})
// getServerSideProps end


export default Root
